import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {TestdrivesComponent} from './testdrives/testdrives.component';

const routes: Routes = [
    {
        path: '',
        component: TestdrivesComponent
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class PlatinumRoutingModule
{
}
